/* eslint-disable react-hooks/exhaustive-deps */
import { Center, Grid, GridItem } from "@chakra-ui/react";
import { customerDashboardStyles } from "theme/overrides/customer";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { userSelector } from "store/user/selector";
import { isEmpty } from "lodash";
import { axiosService } from "network/axios";
import { useNavigate } from "react-router-dom";
import DashboardHeader from "./components/DashboardHeader";
import LatestUpdatesCard from "./components/LatestUpdatesCard";
import PageLayout from "components/layout/PageLayout";
import { EmptyState } from "../projects/components/EmptyState";
import { DashboardMetrics } from "./components/DashboardMetrics";
import AppSpinner from "components/spinner/AppSpinner";
import DashboardErrorBanner from "./components/DashboardErrorBanner";
import { clearDraftStorage } from "views/customer/order/utils/draftStorage";

export default function CustomerDashboard() {
  const boxShadow = customerDashboardStyles.card.boxShadow;
  const navigate = useNavigate();
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const [dashboardTile, setDashboardTile] = useState(null);
  const [lastUpdatedOrders, setLastUpdatedOrders] = useState<any[]>([]);

  const user = useSelector(userSelector);

  useEffect(() => {
    if (!isEmpty(user?.user_id)) {
      fetchSummary(Number(user?.user_id));
    }
  }, [user?.user_id]);

  const fetchSummary = async (user_id: number) => {
    try {
      setIsFetching(true);
      setError(null);
      const { data }: any = await axiosService.get(
        `/projects/customer/summary/${user_id}`
      );

      setDashboardTile({
        totalOrders: data?.totalOrders ?? 0,
        activeOrders: data?.activeProjects ?? 0,
      });

      setLastUpdatedOrders(data?.latestOrders);
    } catch (err: any) {
      console.log(err);
      setError(
        err?.response?.data?.message || 
        err?.message || 
        "Failed to load dashboard data. Please try again."
      );
    } finally {
      setIsFetching(false);
    }
  };

  const goToOrdersPage = () => {
    navigate("/customer/projects");
  };

  const handleStartOrder = () => {
    clearDraftStorage(user?.user_id);
    navigate("/customer/main");
  };

  const openProjectDetails = (order_id: string) => {
    navigate(`/customer/project/${order_id}`);
  };

  const showEmptyState =
    (dashboardTile?.totalOrders ?? 0) < 1 && (lastUpdatedOrders?.length ?? 0) < 1;
    console.log('showEmptyState',showEmptyState);
    console.log('lastUpdatedOrders',lastUpdatedOrders);

  return (
    <PageLayout
      title="Dashboard"
      topContent={error  && <DashboardErrorBanner message={error} />}
    >
      <DashboardHeader
        user={user}
        onPlaceOrder={handleStartOrder}
      />
      {isFetching ? (
        <Center py="80px">
          <AppSpinner />
        </Center>
      ) : showEmptyState ? (
        <EmptyState onStartOrder={handleStartOrder} />
      ) : (
        <>
          <DashboardMetrics dashboardTile={dashboardTile} />

          <Grid
            gap="10px"
            templateColumns={{ lg: "repeat(1, 1fr)", base: "repeat(1, 1fr)" }}
          >
            <GridItem w="100%">
              <LatestUpdatesCard
                boxShadow={boxShadow}
                isFetching={isFetching}
                lastUpdatedOrders={lastUpdatedOrders}
                onViewAll={goToOrdersPage}
                onProjectClick={openProjectDetails}
              />
            </GridItem>
          </Grid>
        </>
      )}

    </PageLayout>
  );
}
